import { atom } from 'jotai';
import type { MapMenu } from './types';

export const mapMenuAtom = atom<MapMenu>({
  stopPointNames: {},
  noEntryZones: {},
  laneletsCenterPoints: false,
});
